import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withTranslation } from '@ifit/rapport-webview';
import I18nType from '../../../shared/i18n-prop-type';
import rapportPackage from './rapport-web.json';
import LineWrap from '@ifit/mp-line-wrap';
import ProgressBar from '@ifit/mp-progress-bar';

const ContinueSeriesInfo = ({ i18n, programInfo, isSeries, small }) => {
  const {
    seriesTitle,
    currentWorkoutIndex,
    numberOfCompletedWorkouts = 0,
    total,
    challengeTitle,
  } = programInfo;

  return (
    <div className={classNames('info', { 'series-info': isSeries })}>
      <div>
        <LineWrap
          className="continue-title"
          maxLines={1}
          text={
            !isSeries
              ? seriesTitle || challengeTitle
              : !small
              ? i18n._translate('Next Up: %{seriesTitle}', {
                  seriesTitle: seriesTitle || challengeTitle,
                })
              : i18n._translate('Next Workout', {
                  context: 'The next workout to view',
                })
          }
        />
        {!isSeries && (
          <div className="continue-sub">
            {programInfo.weekIndex || programInfo.weekIndex === 0 ? (
              <span>
                {i18n._translate(
                  'Week %{weekIndex}, Workout %{workoutOfWeekIndex}',
                  {
                    weekIndex: programInfo.weekIndex + 1,
                    workoutOfWeekIndex: programInfo.workoutOfWeekIndex + 1,
                  }
                )}
              </span>
            ) : (
              <span>
                {i18n._translate(
                  'Workout %{currentWorkoutIndex} of %{seriesWorkoutTotal}',
                  {
                    currentWorkoutIndex: currentWorkoutIndex + 1,
                    seriesWorkoutTotal: total,
                  }
                )}
              </span>
            )}
          </div>
        )}
      </div>
      <div className="icon">
        <span className="card-icon">R</span>
      </div>
      {total && numberOfCompletedWorkouts > 0 && (
        <ProgressBar progress={(numberOfCompletedWorkouts / total) * 100} />
      )}
    </div>
  );
};

ContinueSeriesInfo.propTypes = {
  programInfo: PropTypes.shape({
    seriesId: PropTypes.string,
    seriesTitle: PropTypes.string,
    challengeId: PropTypes.string,
    challengeTitle: PropTypes.string,
    weekIndex: PropTypes.number,
    workoutOfWeekIndex: PropTypes.number,
    total: PropTypes.number,
    numberOfCompletedWorkouts: PropTypes.number,
    currentWorkoutIndex: PropTypes.number,
  }),
  i18n: I18nType,
  isSeries: PropTypes.bool,
  small: PropTypes.bool,
};

ContinueSeriesInfo.defaultProps = {
  workoutCount: 0,
};

export default withTranslation(rapportPackage)(ContinueSeriesInfo);
